import type { CampaignContent } from '../types/campaign'

export type CampaignContentAction =
  | { kind: 'blocked' }
  | { kind: 'navigate'; to: string }

interface GetCampaignContentActionParams {
  contentType: CampaignContent['content_type']
  /** Jornada bloqueada por `unlock_journey_id` (JourneyProgress.blocked). */
  isBlocked: boolean
  /** uid do nível atual do aluno na jornada, quando já há um. */
  currentLevelUid?: string
  /** Campanha encerrada: o conteúdo dela deixa de levar a lugar nenhum. */
  isCampaignEnded?: boolean
}

/**
 * Para onde um conteúdo de campanha leva o aluno — ou se não leva a lugar
 * nenhum.
 *
 * A campanha era a entrada que escapava do bloqueio de jornada: ela navegava
 * direto para o nível atual sem consultar `unlock_journey_id`, enquanto o card
 * da lista de Jornadas já barrava pelo mesmo estado. A regra vira função de
 * domínio para os dois caminhos decidirem igual, e para o bloqueio ficar
 * coberto por teste em vez de depender de um `if` dentro do componente.
 *
 * Campanha encerrada barra ANTES do tipo de conteúdo: encerrada a campanha,
 * nada dela navega — missão inclusive. O backend recusa a conclusão de todo
 * jeito (Campaigns::EndedContentGuard); aqui é para o aluno não bater na porta.
 */
export function getCampaignContentAction({
  contentType,
  isBlocked,
  currentLevelUid,
  isCampaignEnded = false
}: GetCampaignContentActionParams): CampaignContentAction {
  if (isCampaignEnded) return { kind: 'blocked' }

  if (contentType !== 'Journey') return { kind: 'navigate', to: '/missoes' }

  if (isBlocked) return { kind: 'blocked' }

  return {
    kind: 'navigate',
    to: currentLevelUid ? `/niveis/${currentLevelUid}` : '/jornadas'
  }
}
